import { Fragment, ReactElement } from 'react';
import { DeathAnscNotificationsResidentCancellationsCrumbs } from 'cancellations/constants/ansc-notifications.crumbs';
import { IdAmbito } from 'shell/constants/id-ambito';
import ResearchDeathNotificationResidentCivilStatusShared from 'shell/components/shared/ansc-notifications/research-death';

const ResearchDeathNotificationResidentCivilStatusPage = (): ReactElement => {
  return (
    <Fragment>
      <ResearchDeathNotificationResidentCivilStatusShared
        scope={IdAmbito.Cancellazioni}
        items={DeathAnscNotificationsResidentCancellationsCrumbs()}
      />
    </Fragment>
  );
};

ResearchDeathNotificationResidentCivilStatusPage.displayName =
  'Research Death Notifications Resident Page component';

export default ResearchDeathNotificationResidentCivilStatusPage;
